import { Injectable } from '@angular/core';
import { HomeTitles } from '@modules/home/models/home-titles.model';
import { GoogleAnalyticsService } from './googleanalytics.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleanalyticsmoduleserviceService {

  constructor(private googleAnalyticsService: GoogleAnalyticsService) { }

  sendDataToAnalyticsOnLegalSubmit() {
    const eventData = {
      event: "login_event",
      'content_type': 'Global Asset Hub',
      'division': 'B2B',
      'site_country': 'US',
      'page_name': 'License Terms and Conditions'
    };
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnHomePageView() {
    const eventData = {
      event: "page_view",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name': "Homepage"
    };
    eventData['event_source'] = this.googleAnalyticsService.getEventSource();
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  getDateValue(dateString: string): Date {
    let dateValue: Date;
  
    if (dateString.includes('T')) {
      // Date is likely in ISO 8601 format 'yyyy-mm-ddTHH:mm:ss.SSSZ'
      const dateParts = dateString.split('T')[0].split('-');
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date object
      const day = parseInt(dateParts[2], 10);
      dateValue = new Date(year, month, day);
    } else {
      // Date is likely in 'yyyy-mm-dd' format
      const dateParts = dateString.split('-');
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date object
      const day = parseInt(dateParts[2], 10);
      dateValue = new Date(year, month, day);
    }
  
    return dateValue;
  }

  sendDataToAnalyticsOnHomePageTitleClick(title: HomeTitles, isNewAssets:boolean) {
    var section:string = null;
    const currentDate = new Date();
    const eventData = {
      event: "click_event",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name' : "Assets - "+title.titleName,
      'intent_click': "View Assets"
    };

    if (isNewAssets) {
      section = 'new assets';
      if(title.releaseDt) {
        const dateValue = new Date(title.releaseDt);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        }
      }
    }
    else {     
      const releaseDate = title.releaseDate;
      const dateToCompare = new Date(releaseDate);
      if (dateToCompare > currentDate) {
        section = 'Coming Soon';
      } else if (dateToCompare <= currentDate) {
        section = 'Released';
      } 
      if(title.releaseDate) {
        const dateValue = new Date(title.releaseDate);
        if (dateValue <= new Date()) {
          eventData['release_status'] = "Released"; 
        } else if (dateValue > new Date()) {
          eventData['release_status'] = "Coming Soon";
        } 
      }
    }
    eventData['page_section'] = section; 
    if(title.gpmsProductId) {
      eventData['gpms_id'] = title.gpmsProductId; 
    }
    if(title.titleName) {
      eventData['property_title'] = title.titleName; 
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnAssetsScreen(originalTitleName:string, eventSource:string,
    titleOverview: any, titleName:string) {
    const eventData = {
      event: "page_view",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name' : "Assets - "+originalTitleName,
      'event_source': eventSource
    };
    if(titleOverview.releaseDate) {
      const dateValue = new Date(titleOverview.releaseDate);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }

    if(titleOverview?.gpmsProductId) {
      eventData['gpms_id'] = titleOverview?.gpmsProductId;
    }
    if(originalTitleName) {
      eventData['property_title'] = originalTitleName;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnOverviewScreen(originalTitleName:string, eventSource:string,
    titleOverview: any,genreCast: any, titleName:string) {
    const eventData = {
      event: "page_view",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'page_name' : 'Overview - '+originalTitleName
     // 'event_source': eventSource,
     // 'event_detail': this.googleAnalyticsService.removeSpecialCharacters(originalTitleName).toLowerCase() + ' overview page view'
    };
    if(titleOverview?.gpmsProductId) {
      eventData['gpms_id'] = titleOverview?.gpmsProductId;
    }
    if(genreCast?.GenreType?.genre) {
      eventData['genres'] = genreCast?.GenreType?.genre.join(', ');
    }
    if(originalTitleName) {
      eventData['property_title'] = originalTitleName;
    }
    if(titleOverview.releaseDate) {
      const dateValue = new Date(titleOverview.releaseDate);
      if (dateValue <= new Date()) {
        eventData['release_status'] = "Released"; 
      } else if (dateValue > new Date()) {
        eventData['release_status'] = "Coming Soon";
      }
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }
  
  sendDataToAnalyticsOnCartEvents(selectedAssets:any, intentClick:string) {
    const eventData = {
      event: "cart_event",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name':'Assets - ' +selectedAssets.original_title_name,
      'intent_click' : intentClick,
      'runner_id': selectedAssets.runner_id.toString()
    };
    if(selectedAssets.original_title_name) {
      eventData['property_title'] = selectedAssets.original_title_name;
    }
    if(selectedAssets.asset_category) {
      eventData['page_section']   = selectedAssets.asset_category.trim().replaceAll('~', ' » ')+ ' - Asset Card - Cart Icon';
      eventData['asset_category'] = selectedAssets.asset_category.trim().replaceAll('~', ' » ');
    }
    if(selectedAssets.file_name) {
      eventData['asset_type'] = selectedAssets.file_name.split('.').pop();
    }
    if(selectedAssets?.gpms_id) {
      eventData['gpms_id'] = selectedAssets?.gpms_id;
    }
    if(selectedAssets.file_name) {
      eventData['asset_type'] = selectedAssets.file_name.split('.').pop();
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnFooterEmailShareClick(selectedAssets:any) {
    
    const eventData = {
      event: "email_event",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'property_title': selectedAssets.original_title_name, 
      'runner_id': selectedAssets.runner_id.toString(),
      'asset_size': selectedAssets.height?.toString() + ' X '+selectedAssets.width?.toString()
    };
    if(selectedAssets.asset_category) {
      eventData['asset_category'] = selectedAssets.asset_category.trim().replaceAll('~', ' » ');
    }
    if(selectedAssets?.gpms_id) {
      eventData['gpms_id'] = selectedAssets?.gpms_id;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnFooterLinkShareClick(selectedAssets:any) {
    const eventData = {
      event: "link_event",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_title': selectedAssets.original_title_name+" assets",
      'property_title': selectedAssets.original_title_name, 
      'runner_id': selectedAssets.runner_id.toString(),
      'asset_size': selectedAssets.height?.toString() + ' X '+selectedAssets.width?.toString()
    };
    if(selectedAssets.asset_category) {
      eventData['asset_category'] = selectedAssets.asset_category.trim().replaceAll('~', ' » ');
    }
    if(selectedAssets?.gpms_id) {
      eventData['gpms_id'] = selectedAssets?.gpms_id;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnItemCartClick(asset:any) {   
    const eventData = {
      event: "buttonclick",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name': asset.original_title_name,
      'property_title': asset.original_title_name, 
      'runner_id': asset.runner_id.toString(),
      'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
    };
    if(asset.asset_category) {
      eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
    }
    if(asset?.gpms_id) {
      eventData['gpms_id'] = asset?.gpms_id;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnAssetDownloadButtonClick(assetInfo:any, assetFileName:string, titleName:string,
    downloadType:string, proxyType:string, screenType: string) {
    const eventData = {
      event: "download_event",
      'content_type': 'Global Asset Hub', 
      'division': 'B2B',
      'site_country': 'US',
      'intent_click': "Download - Individual Operation",
      'page_name' : 'Download Options - Popup'
    };
    if(assetInfo && assetInfo.asset_category && screenType) {
      eventData['page_section'] = 'Preview - Download Icon';
    }
    else {
      eventData['page_section'] = assetInfo.asset_category.trim().replaceAll('~', ' » ')+ ' - Asset Card - Download Icon';
    }
    if(assetInfo?.gpms_id) {
      eventData['gpms_id'] = assetInfo?.gpms_id;
    }
    if(titleName) {
      eventData['property_title'] = titleName;
    }
    if(assetInfo.runner_id) {
      eventData['runner_id'] = assetInfo.runner_id.toString();
    }
    if(assetInfo && assetInfo.asset_category) {
      eventData['asset_category'] = assetInfo.asset_category.trim().replaceAll('~', ' » ');
    }
    if(assetFileName) {
      eventData['asset_type'] = assetFileName.split('.').pop();
    }
   
    if(assetInfo && assetInfo.height && assetInfo.width) {
      eventData['asset_size'] = assetInfo.height?.toString() + ' X '+assetInfo.width?.toString();
    }
    if(downloadType) {
      eventData['download_method'] = downloadType;
    }
    if(proxyType && proxyType == 'original') {
      eventData['asset_resolution_type'] = 'High Resolution';
    }
    else {
      eventData['asset_resolution_type'] = 'Standard Resolution';
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnAssetPreviewClick(asset:any) {
    const eventData = {
      event: "page_view",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',
      'page_name': asset.file_name+ " preview"
    };
    eventData['event_source'] = this.googleAnalyticsService.getEventSource();
    if(asset && asset.height && asset.width) {
      eventData['asset_size'] = asset.height?.toString() + ' X '+asset.width?.toString();
    }
    if(asset && asset.asset_category) {
      eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
    }
    if(asset && asset.runner_id) {
      eventData['runner_id'] = asset.runner_id.toString();
    }
    if(asset?.gpms_id) {
      eventData['gpms_id'] = asset?.gpms_id;
    }
    if(asset && asset?.original_title_name) {
      eventData['property_title'] = asset.original_title_name;
    }
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }

  sendDataToAnalyticsOnBulkDownloadCart(downloadFileData:any[], downloadMethod:string, assetProxyType:string) {
    downloadFileData.forEach(element => {
      const eventData = {
        event: "download_event",
        'intent_click': "Download - Bulk Operation",
        'content_type': 'Global Asset Hub', 
        'division': 'B2B',
        'site_country': 'US',
        'page_name': 'Download Options - Popup',
        'page_section' : 'Information Bar - Download Icon',
        'property_title': element.title_name, 
        'runner_id': element.runner_id.toString(),
        'asset_size': element.height +' X '+element.width,
        'download_method': downloadMethod
      };
      if(element.asset_category) {
        eventData['asset_category'] = element.asset_category.trim().replaceAll('~', ' » ');
      }
      if(assetProxyType && assetProxyType == 'original') {
        eventData['asset_resolution_type'] = 'High Resolution';
      }
      else {
        eventData['asset_resolution_type'] = 'Standard Resolution';
      }
      if(element?.file_name) {
        eventData['asset_type'] = element.file_name.split('.').pop();
      }
      this.googleAnalyticsService.sendDataToAnalytics(eventData);
    });
  }

  sendDataToAnalyticsOnItemLinkShareEvents(asset:any, sharePermissionCode:string, expirationDate:any, email:string, intentClick:string) {   
    const eventData = {
      event: "share_event",
      event_action: "Share Link",
      'content_type': 'Global Asset Hub', 
      'site_country': 'US',
      'division': 'B2B',    
      'asset_size': asset.height?.toString() + ' X '+asset.width?.toString()
    };
    if(asset.asset_category) {
      eventData['asset_category'] = asset.asset_category.trim().replaceAll('~', ' » ');
    }
    if(asset.original_title_name) {
      eventData['property_title'] = asset.original_title_name;
    }
    if(asset.operation) {
      eventData['intent_click'] = asset.operation;
      eventData['page_section'] = asset.operation;
    }
    else if(intentClick) {
      eventData['intent_click'] = intentClick;
      eventData['page_section'] = intentClick;
    }
    if(sharePermissionCode) {
      if(sharePermissionCode == 'D') {
        eventData['download_permission'] = 'download';
      }
      if(sharePermissionCode == 'PO') {
        eventData['download_permission'] = 'preview only';
      }
      if(sharePermissionCode == 'POD') {
        eventData['download_permission'] = 'proxy download';
      }
    }
    if(email) {
      eventData['protected_link'] = 'yes'; 
    }
    else {
      eventData['protected_link'] = 'no';
    }
    if(expirationDate) {
      eventData['link_expiration'] = expirationDate.toString();
    }
    if(asset?.gpms_id) {
      eventData['gpms_id'] = asset?.gpms_id;
    }
    eventData['asset_type'] = asset.file_name ? asset.file_name.toLowerCase().split('.').pop() : asset.fileName.toLowerCase().split('.').pop();
    eventData['runner_id']  = asset.runner_id ? asset.runner_id.toString() : asset.runnerId.toString();
    this.googleAnalyticsService.sendDataToAnalytics(eventData);
  }
}